<template>
  <div class="chuKuZuoyeWarp">
    <div class="chuKuZuoyeWarp-body">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="银行卡充值" name="first">
          <!-- 查询条件 -->
          <div class="inpBox" ref="searchBox">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
              <el-form-item label="充值时间:">
                <el-date-picker
                  v-model="formInline.startTime1"
                  size="mini"
                  style="width:195px"
                  placeholder="选择日期"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>- &nbsp;&nbsp;&nbsp;
                <el-date-picker
                  v-model="formInline.endTime1"
                  size="mini"
                  style="width:195px"
                  placeholder="选择日期"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="用户名称:">
                <el-input
                  @input="chengeInput($event)"
                  clearable
                  v-model="formInline.kehuName"
                  style="width:175px;"
                  size="mini"
                  placeholder="请输入用户名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="充值银行卡:">
                <el-input
                  @input="chengeInput($event)"
                  clearable
                  v-model="formInline.KaHao"
                  style="width:175px;"
                  size="mini"
                  placeholder="请输入充值银行卡"
                ></el-input>
              </el-form-item>
            </el-form>
            <div style="margin-left:20px;">
              <el-button
                type="primary"
                size="mini"
                @click="chaxun"
                btnCode="00JP005B001"
                v-if="btnFlg[0]"
              >查询</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="chongZhi()"
                btnCode="00JP005B002"
                v-if="btnFlg[1]"
              >重置</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="addBank()"
                btnCode="00JP005B003"
                v-if="btnFlg[2]"
              >添加</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="changeBank()"
                btnCode="00JP005B004"
                v-if="btnFlg[3]"
              >修改</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="detBank()"
                btnCode="00JP005B005"
                v-if="btnFlg[4]"
              >删除</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="accountBank()"
                btnCode="00JP005B006"
                v-if="btnFlg[5]"
              >充值到账</el-button>
              <el-button
              btnCode="00JP005B00A"
                v-if="btnFlg[9]"
              :disabled='isDisableYH'
                type="primary"
                size="mini"
                @click="daochuYH()"
              >导出</el-button>
            </div>
          </div>
          <!--表格1-->
          <div class="chuKuZuoyeWarp-body-table" :style="{height:h}">
            <el-table
              border
              height="100%"
              size="mini"
              ref="tabref1"
              :data="cangchuTableData"
              style="width:100%"
              class="elTab"
              highlight-current-row
              @row-click="dianjixuanzhongBank"
              :header-cell-style="{background:'#F5F5F5',color:'black'}"
            >
              <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
              <el-table-column
                :formatter="emptyFn"
                prop="customerName"
                label="用户名称"
                align="center"
                width="250"
              ></el-table-column>
              <el-table-column
                :formatter="emptyFn"
                prop="accountCode"
                label="钱包账户"
                align="center"
                width="150"
              ></el-table-column>
              <el-table-column
                :formatter="emptyFn"
                prop="rechargeMoney"
                label="充值金额"
                align="center"
                width="150"
              ></el-table-column>
              <el-table-column
                :formatter="emptyFn"
                prop="rechargeAccount"
                label="充值银行卡"
                align="center"
              ></el-table-column>
              <el-table-column prop="rechargeStatus" label="充值状态" align="center" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.rechargeStatus =='待充值'" style="color:red;">待充值</span>
                  <span v-else-if="scope.row.rechargeStatus =='已充值'">已充值</span>
                </template>
              </el-table-column>
              <el-table-column prop="remitRemark" label="备注" align="center" :formatter="emptyFn"></el-table-column>
              <el-table-column
                prop="remitTime"
                label="转账时间"
                align="center"
                width="100"
                :formatter="dateFormat"
              ></el-table-column>
              <el-table-column
                prop="rechargeTime"
                label="充值时间"
                align="center"
                width="100"
                :formatter="dateFormat"
              ></el-table-column>
              <el-table-column prop="outstockDate" label="操作" align="center">
                <template slot-scope="scope">
                  <!-- <span v-if="scope.row.remitVoucher==''">未上传</span>
              <span v-if="scope.row.remitVoucher==undefined ||scope.row.remitVoucher==null">未上传</span>
                  <span v-if="scope.row.remitVoucher !=='' &&scope.row.remitVoucher !==undefined"> </span>-->
                  <el-button
                    type="text"
                    size="mini"
                    @click="seeClick(scope.row)"
                    btnCode="00JP005B007"
                    v-if="btnFlg[6]"
                  >查看凭证</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--分页-->
          <div class="pags" style="text-align: left;">
            <el-pagination
              background
              @current-change="handleCurrentChangeA"
              :current-page="current"
              :page-size="pagesize"
              :page-sizes="[10, 20, 30, 40,50]"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChangeA"
              :total="total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="微信充值" name="second">
          <!-- 查询条件 -->
          <div class="inpBox" ref="searchBox">
            <el-form :inline="true" :model="formInline1" class="demo-form-inline">
              <el-form-item label="充值时间:">
                <el-date-picker
                  v-model="formInline1.startTime2"
                  size="mini"
                  style="width:195px"
                  placeholder="选择日期"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>- &nbsp;&nbsp;&nbsp;
                <el-date-picker
                  v-model="formInline1.endTime2"
                  size="mini"
                  style="width:195px"
                  placeholder="选择日期"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="用户名称:">
                <el-input
                  @input="chengeInput($event)"
                  clearable
                  v-model="formInline1.kehuName"
                  style="width:175px;"
                  size="mini"
                  placeholder="请输入用户名称"
                ></el-input>
              </el-form-item>
            </el-form>
            <div style="margin-left:20px;">
              <el-button
                type="primary"
                size="mini"
                @click="chaxun1"
                btnCode="00JP005B008"
                v-if="btnFlg[7]"
              >查询</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="chongZhi1()"
                btnCode="00JP005B009"
                v-if="btnFlg[8]"
              >重置</el-button>
              <el-button
               btnCode="00JP005B00B"
                v-if="btnFlg[10]"
              :disabled='isDisableWX'
                type="primary"
                size="mini"
                @click="daochuWX()"
              >导出</el-button>
            </div>
          </div>
          <div class="chuKuZuoyeWarp-body-table" :style="{height:h}">
            <el-table
              border
              height="100%"
              size="mini"
              ref="tabref"
              :data="cangchuTableData1"
              style="width:100%"
              class="elTab"
              highlight-current-row
              @row-click="dianjixuanzhong"
              :header-cell-style="{background:'#F5F5F5',color:'black'}"
            >
              <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
              <el-table-column :formatter="emptyFn" prop="customerName" label="用户名称" align="center"></el-table-column>
              <el-table-column prop="accountCode" label="钱包账户" align="center" :formatter="emptyFn"></el-table-column>
              <el-table-column
                prop="rechargeMoney"
                label="充值金额"
                align="center"
                :formatter="emptyFn"
              ></el-table-column>
              <el-table-column prop="accountCode" label="充值微信" align="center" :formatter="emptyFn"></el-table-column>
              <el-table-column prop="remitRemark" label="备注" align="center" :formatter="emptyFn"></el-table-column>
              <el-table-column
                prop="rechargeTime"
                label="充值时间"
                align="center"
                :formatter="dateFormat"
              ></el-table-column>
            </el-table>
          </div>
          <!--分页-->
          <div class="pags" style="text-align: left;">
            <el-pagination
              background
              @current-change="handleCurrentChangeB"
              :current-page="current1"
              :page-size="pagesize1"
              :page-sizes="[10, 20, 30, 40,50]"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChangeB"
              :total="total1"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!--点击添加按钮弹出框-->
      <div class="addMarkBox">
        <el-dialog
          custom-class="el-dialog--center"
          title="添加"
          :visible.sync="addMarkBank"
          :close-on-click-modal="false"
          width="50%"
          center
          :before-close="handleClose"
        >
          <div v-loading="loading1">
            <!--form表单-->
            <el-form
              :model="addFormData"
              ref="addFormData"
              label-width="100px"
              class="demo-dynamic"
              style="width:510px;margin:30px auto;"
            >
              <el-form-item
                label="用户名称"
                prop="kehuName"
                :rules="[
                { required: true, message: '请输入用户名称', trigger: 'blur' },
              ]"
              >
                <el-select
                  size="mini"
                  filterable
                  v-model="addFormData.kehuName"
                  @change="changeCode(addFormData.kehuName)"
                  placeholder="请选择用户名称"
                >
                  <el-option
                    v-for="(item,index) in kehuMing"
                    :label="item.accountName"
                    :key="index"
                    :value="item.accountCode"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="钱包账户"
                prop="zhangHu"
                :rules="[
                { required: true, message: '请输入钱包账户', trigger: 'blur' },
              ]"
              >
                <el-input
                  @input="chengeInput($event)"
                  clearable
                  disabled
                  placeholder="请输入钱包账户"
                  size="mini"
                  v-model="addFormData.zhangHu"
                  style="width:193px;"
                  maxlength="10"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="kaHao"
                label="银行卡号"
                :rules="[
                { required: true, message: '请输入银行卡号', trigger: 'blur' },
              ]"
              >
                <el-input
                  @input="chengeInput($event)"
                  clearable
                  onkeyup="value=value.replace(/\D/g,'').replace(/....(?!$)/g,'$&')"
                  placeholder="请输入银行卡号"
                  size="mini"
                  v-model="addFormData.kaHao"
                  style="width:193px;"
                  maxlength="20"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="jine"
                label="充值金额"
                :rules="[
                { required: true, message: '请填写充值金额，只能填写数字', trigger: 'blur'},
                {pattern:/^\d{1,20}(\.\d{1,3})?$/, message: '充值金额精确到三位小数点'}]"
              >
                <el-input
                  @input="chengeInput($event)"
                  clearable
                  oninput="value=value.replace(/\D*(\d*)(\.?)(\d{0,3})\d*/,'$1$2$3')"
                  maxlength="15"
                  placeholder="请输入充值金额"
                  size="mini"
                  v-model="addFormData.jine"
                  style="width:193px;"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="time"
                label="转账时间"
                :rules="[
                { required: true, message: '请输入转账时间', trigger: 'blur' },
              ]"
              >
                <el-date-picker
                  v-model="addFormData.time"
                  size="mini"
                  style="width:195px"
                  placeholder="选择日期"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="备注">
                <el-input
                  @input="chengeInput($event)"
                  clearable
                  maxlength="200"
                  placeholder="请输入备注"
                  size="mini"
                  v-model="addFormData.remark"
                  style="width:193px;"
                ></el-input>
              </el-form-item>
              <el-form-item prop="img" label="转账凭证">
                <div>
                  <el-upload
                    action
                    :file-list="listImg"
                    ref="upload"
                    :auto-upload="false"
                    :on-change="imgPreview"
                    list-type="picture-card"
                    accept="image/*"
                    :limit="1"
                    :on-remove="handleRemove"
                    :class="[isAddImg?'hidden':'']"
                  ></el-upload>
                </div>
              </el-form-item>
            </el-form>
            <div style="margin:15px auto;" class="el-dialog--center">
              <el-button type="primary" @click="addQueding('addFormData')">确定</el-button>
              <el-button type="primary" @click="quxiao">取消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
      <!--点击修改按钮弹出框-->
      <div class="addMarkBox">
        <el-dialog
          custom-class="el-dialog--center"
          title="修改"
          :visible.sync="changeMarkBank"
          :close-on-click-modal="false"
          width="50%"
          center
          :before-close="handleClose"
        >
          <div v-loading="loading2">
            <!--form表单-->
            <el-form
              :model="changeFormData"
              ref="changeFormData"
              label-width="100px"
              class="demo-dynamic"
              style="width:510px;margin:30px auto;"
            >
              <el-form-item
                label="用户名称"
                prop="kehuName"
                :rules="[
                { required: true, message: '请输入用户名称', trigger: 'blur' },
              ]"
              >
                <el-select
                  size="mini"
                  filterable
                  v-model="changeFormData.kehuName"
                  @change="changeCode(changeFormData.kehuName)"
                  placeholder="请选择用户名称"
                >
                  <el-option
                    v-for="(item,index) in kehuMing"
                    :label="item.accountName"
                    :key="index"
                    :value="item.accountCode"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                prop="zhangHu"
                :rules="[
                { required: true, message: '请输入钱包账户', trigger: 'blur' },
              ]"
                label="钱包账户"
              >
                <el-input
                  @input="chengeInput($event)"
                  clearable
                  disabled
                  placeholder="请输入钱包账户"
                  size="mini"
                  v-model="changeFormData.zhangHu"
                  style="width:193px;"
                  maxlength="20"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="kaHao"
                label="银行卡号"
                :rules="[
                { required: true, message: '请输入银行卡号', trigger: 'blur' },
              ]"
              >
                <el-input
                  @input="chengeInput($event)"
                  clearable
                  onkeyup="value=value.replace(/\D/g,'').replace(/....(?!$)/g,'$&')"
                  placeholder="请输入银行卡号"
                  size="mini"
                  v-model="changeFormData.kaHao"
                  style="width:193px;"
                  maxlength="20"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="jine"
                label="充值金额"
                :rules="[
                { required: true, message: '请填写充值金额，只能填写数字', trigger: 'blur'},
                {pattern:/^\d{1,20}(\.\d{1,3})?$/, message: '充值金额精确到三位小数点'}]"
              >
                <el-input
                  @input="chengeInput($event)"
                  clearable
                  oninput="value=value.replace(/\D*(\d*)(\.?)(\d{0,3})\d*/,'$1$2$3')"
                  maxlength="15"
                  placeholder="请输入充值金额"
                  size="mini"
                  v-model="changeFormData.jine"
                  style="width:193px;"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="time"
                label="转账时间"
                :rules="[
                { required: true, message: '请输入转账时间', trigger: 'blur' },
              ]"
              >
                <el-date-picker
                  v-model="changeFormData.time"
                  size="mini"
                  style="width:195px"
                  placeholder="选择日期"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="备注">
                <el-input
                  @input="chengeInput($event)"
                  clearable
                  maxlength="200"
                  placeholder="请输入备注"
                  size="mini"
                  v-model="changeFormData.remark"
                  style="width:193px;"
                ></el-input>
              </el-form-item>
              <el-form-item prop="img" label="转账凭证">
                <div v-if="srcFlag==0" class="chengeimg">
                  <img :src="src2" />
                  <span>
                    <el-button type="text" @click="chengeImg">修改</el-button>
                  </span>
                </div>
                <div v-else-if="srcFlag==1">
                  <el-upload
                    action
                    :file-list="listImg"
                    ref="upload"
                    :auto-upload="false"
                    :on-change="imgPreview"
                    list-type="picture-card"
                    accept="image/*"
                    :limit="1"
                    :on-remove="handleRemove"
                    :class="[isAddImg?'hidden':'']"
                  ></el-upload>
                </div>
              </el-form-item>
            </el-form>
            <div style="margin:15px auto;" class="el-dialog--center">
              <el-button type="primary" @click="changeQueding('changeFormData')">确定</el-button>
              <el-button type="primary" @click="quxiao">取消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
      <!--点击充值到账按钮弹出框-->
      <div class="addMarkBox">
        <el-dialog
          custom-class="el-dialog--center"
          v-loading="loading3"
          title="充值到账"
          :visible.sync="accountMarkBank"
          :close-on-click-modal="false"
          width="50%"
          center
        >
          <!--form表单1111-->
          <el-form
            :model="accountFormData"
            ref="accountFormData"
            label-width="100px"
            class="demo-dynamic"
            style="width:510px;margin:30px auto;"
          >
            <el-form-item label="用户名称">
              <el-input
                @input="chengeInput($event)"
                clearable
                disabled
                maxlength="25"
                placeholder="请输入用户名称"
                size="mini"
                v-model="accountFormData.kehuName"
                style="width:193px;"
              ></el-input>
            </el-form-item>
            <el-form-item label="钱包账户">
              <el-input
                @input="chengeInput($event)"
                clearable
                disabled
                placeholder="请输入钱包账户"
                size="mini"
                v-model="accountFormData.zhangHu"
                style="width:193px;"
                maxlength="10"
              ></el-input>
            </el-form-item>
            <el-form-item label="充值金额">
              <el-input
                @input="chengeInput($event)"
                clearable
                disabled
                maxlength="25"
                placeholder="请输入充值金额"
                size="mini"
                v-model="accountFormData.jine"
                style="width:193px;"
              ></el-input>
            </el-form-item>
            <el-form-item label="转账时间">
              <el-input
                @input="chengeInput($event)"
                clearable
                disabled
                maxlength="25"
                placeholder="请输入转账时间"
                size="mini"
                v-model="accountFormData.time"
                style="width:193px;"
              ></el-input>
            </el-form-item>
          </el-form>
          <div style="margin:15px auto;" class="el-dialog--center">
            <el-button type="primary" @click="accountQueding('accountFormData')">充值到账</el-button>
            <el-button type="primary" @click="accountMarkBank = false">取消</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- 查看凭证弹窗 -->
      <div v-loading="loading">
        <el-dialog
          title="查看凭证"
          :visible.sync="imgMark"
          :close-on-click-modal="false"
          width="40%"
          center
          custom-class="el-dialog--center"
        >
          <div class="block">
            <span class="demonstration"></span>
            <el-image :src="src"></el-image>
          </div>
          <!-- ----------------------------------------------------------------------------------运单 -->
          <div style="margin:15px auto;" class="el-dialog--center">
            <el-button type="primary" @click="imgMark=false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import { emptyFn } from '@/utils/util'
import { exportExcel } from '@/utils/fileDown.js'

import {
  tRechargeInfoList,
  tRechargeInfoAdd, // 新增
  bPayDictionaryUploadFile, // 图片上传
  tRechargeInfoDelete, // 删除
  tRechargeInfoUpdateStatus, // 充值到账
  tRechargeInfoUpdate, // 修改
  listAllCustomer
} from '@/api/common-signature'
export default {
  name: 'Recharge',
  data () {
    let token = window.localStorage.getItem('zhonghouban-tokens')
    var jsonObj = JSON.parse(token)
    return {
      isDisableYH: false,
      isDisableWX: false,
      emptyFn: emptyFn,
      loading1: false,
      loading2: false,
      loading3: false,
      selectIdList: [],
      detId: [], // 删除数组
      //
      costId: '',
      accountCode: '',
      customerCode: '',
      customerName: '',
      //
      loading: false,
      src: '',
      src2: '',
      srcFlag: 0,
      imgMark: false, // 查看凭证
      isAddImg: false,
      listImg: [],
      imgUrl: [],
      imgfile: new FormData(),
      header: { Authorization: 'Bearer ' + jsonObj },

      // ---------------------银行卡
      addFormData: {
        zhangHu: '',
        kehuName: '',
        jine: '',
        time: '',
        kaHao: '',
        img: '',
        remark: ''
      }, // 表单
      changeFormData: {
        zhangHu: '',
        kehuName: '',
        jine: '',
        time: '',
        kaHao: '',
        img: '',
        remark: ''
      }, // 表单
      accountFormData: {}, // 表单
      addMarkBank: false,
      changeMarkBank: false,
      accountMarkBank: false,
      // -----------------
      activeName: 'first',
      //= ========================
      h: '500px',
      num: 0,
      cangchuTableData: [],
      cangchuTableData1: [],
      typeData: [],
      kehuMing: [],
      zhuanTaiData: [],
      xuanzhongArr: [],
      xuanzhongArrBank: [],
      // 查询条件
      formInline: {},
      formInline1: {},
      zhuanTaiID: '',
      zhuanTaiID1: '',
      pagesize: 20,
      current: 1,
      total: 0,
      pagesize1: 20,
      current1: 1,
      total1: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '00JP005B001',
        '00JP005B002',
        '00JP005B003',
        '00JP005B004',
        '00JP005B005',
        '00JP005B006',
        '00JP005B007',
        '00JP005B008',
        '00JP005B009',
        '00JP005B00A',
        '00JP005B00B'
      ]
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/userWallet/recharge')
    this.tRechargeInfoListS()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 220 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    chengeInput () {
      this.$forceUpdate()
    },

    // 点击查看凭证
    seeClick (row) {
      this.imgMark = true
      this.loading = false
      this.src = row.remitVoucher
    },
    // 点击关闭弹窗
    handleClose (done) {
      this.addMarkBank = false
      this.changeMarkBank = false
      this.changeFormData = {}
      this.addFormData = {}
      this.src = ''
      this.src2 = ''
      this.srcFlag = 0
      this.listImg = []
      this.isAddImg = false
      // this.$refs['changeFormData'].resetFields()
      // this.$refs['addFormData'].resetFields()
      this.$nextTick(() => {
        //   this.$refs['changeFormData'].resetFields()
        // this.$refs['addFormData'].resetFields()
        if (this.$refs.addFormData !== undefined) {
          this.$refs.addFormData.resetFields()
        }
        if (this.$refs.changeFormData !== undefined) {
          this.$refs.changeFormData.resetFields()
        }
      })
    },
    quxiao () {
      this.addMarkBank = false
      this.changeMarkBank = false
      // this.changeFormData = {}
      // this.addFormData = {}
      this.src = ''
      this.src2 = ''
      this.srcFlag = 0
      this.listImg = []
      this.isAddImg = false
      // this.$refs['changeFormData'].resetFields()
      // this.$refs['addFormData'].resetFields()
      this.$nextTick(() => {
        //   this.$refs['changeFormData'].resetFields()
        // this.$refs['addFormData'].resetFields()
        if (this.$refs.addFormData !== undefined) {
          this.$refs.addFormData.resetFields()
        }
        if (this.$refs.changeFormData !== undefined) {
          this.$refs.changeFormData.resetFields()
        }
      })
    },
    // ----------------------------------------------------银行卡
    // 查询
    chaxun () {
      this.tRechargeInfoListS()
    },
    // 重置
    chongZhi () {
      this.formInline = {}
      this.tRechargeInfoListS()
    },
    // 添加、
    addBank () {
      this.addMarkBank = true
      this.addFormData = {}
      this.listAllCustomerS()
    },
    changeCode: function (valueS) {
      let choosenItem = this.kehuMing.filter(
        (item) => item.accountCode === valueS
      )[0]
      // choosenItem 中有你需要的所有信息
      this.costId = choosenItem.id
      this.customerCode = choosenItem.accountCode
      this.customerName = choosenItem.accountName
      this.addFormData.zhangHu = choosenItem.loginUser // 账号
      this.addFormData.kaHao = choosenItem.bankAccount // 卡号
      this.changeFormData.zhangHu = choosenItem.loginUser // 账号
      this.changeFormData.kaHao = choosenItem.bankAccount // 卡号
    },
    addQueding (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.listImg.length == 0) {
            DonMessage.error('请先上传凭证')
          } else {
            if (this.listImg.length == 0) {
              DonMessage.error('请选择需要上传的图片!')
            } else {
              let imgfile = new FormData()
              for (var i = 0; i < this.listImg.length; i++) {
                imgfile.append('uploadFile', this.listImg[i].raw)
              }
              // let numId = { changeIdPicture: this.xuanzhongArr.changeId }
              imgfile.append('params', JSON.stringify())
              this.loading1 = true

              bPayDictionaryUploadFile(imgfile)
                .then((res) => {
                  let url = res
                  // 上传图片成功后 - 调用确认提现接口
                  tRechargeInfoAdd({
                    pageNo: this.current, // 页数
                    pageSize: this.pagesize, // 条数
                    customerName: this.customerName, // 客户名称__下拉框获取customerName
                    customerCode: this.customerCode, //   客户code__下拉框获取customerCode
                    rechargeMoney: this.addFormData.jine, //   充值金额
                    rechargeAccount: this.addFormData.kaHao, //   充值银行卡/微信账号__下拉框获取bankAccount——允许修改
                    remitTime: this.addFormData.time, //   线下转账时间
                    remitRemark: this.addFormData.remark, //   线下转账备注
                    remitVoucher: url, //   线下充值凭证
                    costId: this.costId, //  钱包id__下拉框获取id
                    accountCode: this.addFormData.zhangHu //   钱包账户__下拉框获取loginUser
                  })
                    .then((res) => {
                      DonMessage.success('操作成功!')

                      this.addMarkBank = false
                      this.tRechargeInfoListS()
                      this.listImg = []
                      this.isAddImg = false
                      this.loading1 = false
                    })
                    .catch((err) => {
                      DonMessage.error(err.message)
                      this.loading1 = false
                    })
                })
                .catch((err) => {
                  DonMessage.error(err.message)
                })
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改
    changeBank () {
      this.srcFlag = 0
      if (!this.xuanzhongArrBank.rechargeStatus) {
        DonMessage.error('请选择要操作的数据')
      } else if (this.xuanzhongArrBank.rechargeStatus !== '待充值') {
        DonMessage.error('只能操作待充值状态数据')
      } else {
        this.changeMarkBank = true
        this.listAllCustomerS()
        var t = new Date(this.xuanzhongArrBank.remitTime) // row 表示一行数据, transferTime 表示要格式化的字段名称
        var month =
          t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
        var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
        var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
        var minutes =
          t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
        var seconds =
          t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
        if (
          this.xuanzhongArrBank.remitTime == null ||
          this.xuanzhongArrBank.remitTime == '-'
        ) {
          this.xuanzhongArrBank.remitTime = '-'
        } else {
          this.xuanzhongArrBank.remitTime =
            t.getFullYear() +
            '-' +
            month +
            '-' +
            date +
            ' ' +
            hour +
            ':' +
            minutes +
            ':' +
            seconds
        }
        console.log(this.xuanzhongArrBank.rechargeAccount)
        this.changeFormData.zhangHu = this.xuanzhongArrBank.accountCode
        this.changeFormData.kehuName = this.xuanzhongArrBank.customerName
        this.changeFormData.jine = this.xuanzhongArrBank.rechargeMoney
        // this.$set(this.changeFormData, 'jine', this.xuanzhongArrBank.rechargeMoney)
        this.changeFormData.time = this.xuanzhongArrBank.remitTime
        this.changeFormData.kaHao = this.xuanzhongArrBank.rechargeAccount
        this.changeFormData.remark = this.xuanzhongArrBank.remitRemark
        this.src2 = this.xuanzhongArrBank.remitVoucher
      }
    },
    chengeImg () {
      this.srcFlag = 1
    },
    changeQueding (formName) {
      this.$refs[formName].validate((valid) => {
        console.log(this.xuanzhongArrBank.accountName)

        if (valid) {
          if (this.srcFlag == 0) {
            this.loading2 = true
            tRechargeInfoUpdate({
              pageNo: this.current, // 页数
              pageSize: this.pagesize, // 条数
              ext1: '1',

              id: this.xuanzhongArrBank.id,
              customerName:
                this.customerName || this.xuanzhongArrBank.accountName, // 客户名称__下拉框获取customerName
              customerCode:
                this.customerCode || this.xuanzhongArrBank.accountCode, //   客户code__下拉框获取customerCode
              rechargeMoney: this.changeFormData.jine, //   充值金额
              rechargeAccount: this.changeFormData.kaHao, //   充值银行卡/微信账号__下拉框获取bankAccount——允许修改
              remitTime: this.changeFormData.time, //   线下转账时间
              remitRemark: this.changeFormData.remark, //   线下转账备注
              remitVoucher: this.xuanzhongArrBank.remitVoucher, //   线下充值凭证
              costId: this.costId || this.xuanzhongArrBank.costId, //  钱包id__下拉框获取id
              accountCode: this.changeFormData.zhangHu //   钱包账户__下拉框获取loginUser
            })
              .then((res) => {
                this.loading2 = false
                DonMessage.success('操作成功!')
                this.changeMarkBank = false
                this.tRechargeInfoListS()
                this.listImg = []
                this.isAddImg = false
              })
              .catch((err) => {
                this.loading2 = false

                DonMessage.error(err.message)
              })
          } else if (this.listImg.length == 0) {
            DonMessage.error('请先上传凭证')
          } else {
            if (this.listImg.length == 0) {
              DonMessage.error('请选择需要上传的图片!')
            } else {
              let imgfile = new FormData()
              for (var i = 0; i < this.listImg.length; i++) {
                imgfile.append('uploadFile', this.listImg[i].raw)
              }
              // let numId = { changeIdPicture: this.xuanzhongArr.changeId }
              imgfile.append('params', JSON.stringify())
              this.loading2 = true

              bPayDictionaryUploadFile(imgfile)
                .then((res) => {
                  let url = res
                  // 上传图片成功后 - 调用确认提现接口
                  tRechargeInfoUpdate({
                    pageNo: this.current, // 页数
                    pageSize: this.pagesize, // 条数
                    ext1: '2',
                    id: this.xuanzhongArrBank.id,
                    customerName:
                      this.customerName || this.xuanzhongArrBank.accountName, // 客户名称__下拉框获取customerName
                    customerCode:
                      this.customerCode || this.xuanzhongArrBank.accountCode, //   客户code__下拉框获取customerCode
                    rechargeMoney: this.changeFormData.jine, //   充值金额
                    rechargeAccount: this.changeFormData.kaHao, //   充值银行卡/微信账号__下拉框获取bankAccount——允许修改
                    remitTime: this.changeFormData.time, //   线下转账时间
                    remitRemark: this.changeFormData.remark, //   线下转账备注
                    remitVoucher: url, //   线下充值凭证
                    costId: this.costId || this.xuanzhongArrBank.costId, //  钱包id__下拉框获取id
                    accountCode: this.changeFormData.zhangHu //   钱包账户__下拉框获取loginUser
                  })
                    .then((res) => {
                      DonMessage.success('操作成功!')
                      this.loading2 = false

                      this.changeMarkBank = false
                      this.tRechargeInfoListS()
                      this.listImg = []
                      this.isAddImg = false
                    })
                    .catch((err) => {
                      this.loading2 = false

                      DonMessage.error(err.message)
                    })
                })
                .catch((err) => {
                  DonMessage.error(err.message)
                })
            }
          }
          this.srcFlag = 0
        } else {
          return false
        }
      })
    },

    // 删除
    detBank () {
      if (!this.xuanzhongArrBank.rechargeStatus) {
        DonMessage.error('请选择要操作的数据')
      } else if (this.xuanzhongArrBank.rechargeStatus !== '待充值') {
        DonMessage.error('只能操作待充值状态数据')
      } else {
        this.$confirm('是否确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            tRechargeInfoDelete({
              id: this.xuanzhongArrBank.id //  钱包id__下拉框获取id
            })
              .then((res) => {
                DonMessage.success('操作成功!')
                this.tRechargeInfoListS()
              })
              .catch((err) => {
                DonMessage.error(err.message)
              })
          })
          .catch(() => {})
      }
    },
    // 充值到账
    accountBank () {
      var t = new Date(this.xuanzhongArrBank.remitTime) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      if (
        this.xuanzhongArrBank.remitTime == null ||
        this.xuanzhongArrBank.remitTime == '-'
      ) {
        this.xuanzhongArrBank.remitTime = '-'
      } else {
        this.xuanzhongArrBank.remitTime =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      if (!this.xuanzhongArrBank.rechargeStatus) {
        DonMessage.error('请选择要操作的数据')
      } else if (this.xuanzhongArrBank.rechargeStatus !== '待充值') {
        DonMessage.error('只能操作待充值状态数据')
      } else {
        this.accountMarkBank = true
        this.accountFormData.zhangHu = this.xuanzhongArrBank.accountCode
        this.accountFormData.jine = this.xuanzhongArrBank.rechargeMoney
        this.accountFormData.time = this.xuanzhongArrBank.remitTime
        this.accountFormData.kehuName = this.xuanzhongArrBank.accountName
      }
    },
    accountQueding (formName) {
      this.$confirm('是否确认充值到账?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading3 = true
          tRechargeInfoUpdateStatus({
            ids: this.xuanzhongArrBank.id // id
          })
            .then((res) => {
              this.accountMarkBank = false
              this.loading3 = false
              DonMessage.success('操作成功!')
              this.tRechargeInfoListS()
            })
            .catch((err) => {
              this.loading3 = false
              DonMessage.error(err.message)
            })
        })
        .catch(() => {})
    },
    // // 复选框改变事件
    // handleSelectionChange (val) {
    //   this.selectIdList = []
    //   this.detId = val
    //   val.forEach((item, index) => {
    //     // this.xuanzhongArr = item
    //     this.selectIdList.push(item.id)
    //   })
    //   this.selectIdList = Array.from(new Set(this.selectIdList)) // 去重获取删除的id
    //   this.selectIdList = this.selectIdList.join(',')
    // },
    // -----------------------------------------------------微信
    handleClick (tab, event) {
      if (tab.index == 0) {
        this.tRechargeInfoListS()
      } else if (tab.index == 1) {
        this.tRechargeInfoListSS()
      }
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row, column, event) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
      this.num = 0
      // 点击行勾选复选框
      this.$refs.tabref1.clearSelection()
      this.$refs.tabref1.toggleRowSelection(row, true)
    },
    dianjixuanzhongBank (row, column, event) {
      this.xuanzhongArrBank = {}
      this.xuanzhongArrBank = row
      this.num = 0
      // 点击行勾选复选框
      this.$refs.tabref1.clearSelection()
      this.$refs.tabref1.toggleRowSelection(row, true)
    },
    // 主数据-0
    tRechargeInfoListS () {
      tRechargeInfoList({
        pageNo: this.current, // 页数
        pageSize: this.pagesize, // 条数
        rechargeAccount: this.formInline.KaHao, //  银行卡号
        customerName: this.formInline.kehuName, //  用户名称
        startTime: this.formInline.startTime1, //  用户名称
        endTime: this.formInline.endTime1, //  用户名称
        rechargeType: 1 //  充值类型1-银行卡充值 2-微信充值
      })
        .then((res) => {
          this.xuanzhongArrBank = {}
          this.total = res.total
          this.cangchuTableData = res.list
          this.cangchuTableData.forEach((item, index) => {
            //  rechargeStatus 充值状态 0-待充值 1-已充值
            if (item.rechargeStatus == 0) {
              item.rechargeStatus = '待充值'
            } else if (item.rechargeStatus == 1) {
              item.rechargeStatus = '已充值'
            }
          })
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 主数据-1
    tRechargeInfoListSS () {
      tRechargeInfoList({
        pageNo: this.current1, // 页数
        pageSize: this.pagesize1, // 条数
        rechargeAccount: this.formInline1.KaHao, //  银行卡号
        customerName: this.formInline1.kehuName, //  用户名称
        startTime: this.formInline1.startTime2, //  用户名称
        endTime: this.formInline1.endTime2, //  用户名称
        rechargeType: 2 //  充值类型1-银行卡充值 2-微信充值
      })
        .then((res) => {
          this.xuanzhongArr = []
          this.total1 = res.total
          this.cangchuTableData1 = res.list
          this.cangchuTableData1.forEach((item, index) => {
            //  rechargeStatus 充值状态 0-待充值 1-已充值
            if (item.rechargeStatus == 0) {
              item.rechargeStatus = '待充值'
            } else if (item.rechargeStatus == 1) {
              item.rechargeStatus = '已充值'
            }
          })
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 获取客户
    listAllCustomerS () {
      listAllCustomer({
        rechargeType: 1 //  充值类型1-银行卡充值 2-微信充值
      })
        .then((res) => {
          // this.xuanzhongArr = []
          // this.total = res.total
          this.kehuMing = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 导出
    daochuYH () {
      this.isDisableYH = true
      setTimeout(() => {
        this.isDisableYH = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
      let form = {
        pageNo: this.current, // 页数
        pageSize: this.pagesize, // 条数
        rechargeAccount: this.formInline.KaHao, //  银行卡号
        customerName: this.formInline.kehuName, //  用户名称
        startTime: this.formInline.startTime1, //  用户名称
        endTime: this.formInline.endTime1, //  用户名称
        rechargeType: 1 //  充值类型1-银行卡充值 2-微信充值
      }
      // fetch(
      exportExcel(
        this.global.payName +
          '/tRechargeInfo/exportOldList',
        form,
        '充值管理-银行卡信息表'
      )
    },
    daochuWX () {
      // 点击导出
      this.isDisableWX = true
      setTimeout(() => {
        this.isDisableWX = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
      let form = {
        pageNo: this.current1, // 页数
        pageSize: this.pagesize1, // 条数
        rechargeAccount: this.formInline1.KaHao, //  银行卡号
        customerName: this.formInline1.kehuName, //  用户名称
        startTime: this.formInline1.startTime2, //  用户名称
        endTime: this.formInline1.endTime2, //  用户名称
        rechargeType: 2 //  充值类型1-银行卡充值 2-微信充值
      }
      // fetch(
      exportExcel(
        this.global.payName +
          '/tRechargeInfo/exportOldList',
        form,
        '充值管理-微信信息表'
      )
    },
    // 查询
    chaxun1 () {
      this.tRechargeInfoListSS()
    },
    // 重置
    chongZhi1 () {
      this.formInline1 = {}
      this.tRechargeInfoListSS()
    },
    // 图片上传
    handleRemove (file, fileList) {
      if (fileList.length < 1) {
        this.isAddImg = false
      }
      // this.addFrom.vhcPhoto1 = ''
      this.listImg = fileList
    },

    imgPreview (file, fileList) {
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/
      if (regex.test(fileName.toLowerCase())) {
        if (fileList.length < 1) {
          this.isAddImg = false
        } else {
          this.isAddImg = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
      this.listImg = fileList
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.current = val
      this.tRechargeInfoListS()
    },
    handleSizeChangeA (val) {
      this.pagesize = val
      this.tRechargeInfoListS()
    },
    // 表格分页
    handleCurrentChangeB (val) {
      this.current1 = val
      this.tRechargeInfoListSS()
    },
    handleSizeChangeB (val) {
      this.pagesize1 = val
      this.tRechargeInfoListSS()
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-upload--picture-card {
  background-image: url("../../../assets/images/upload2.png") !important;
  border: none !important;
}
.hidden /deep/.el-upload--picture-card {
  display: none;
}
/deep/.inpBox .el-input__inner {
  width: 180px !important;
}
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.chengeimg {
  height: 150px;
  width: 180px;
  display: flex;
  img {
    height: 100%;
  }
  span {
    margin-top: 110px;
  }
}
.el-form-item {
  margin-left: 10px;
}
.huoQuanChangeWarp-body-title {
  width: 100%;
  height: 35px;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  box-sizing: border-box;
  span {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #2f2f2f;
    display: inline;
    line-height: 30px;
    // margin-left: 20px;
  }
}
.chuKuZuoyeWarp {
  width: 100%;
  position: relative;
  height: 100%;
  .pags {
    width: 100%;
    text-align: center;
  }
  // border: solid 1px blue;
  .chuKuZuoyeWarp-body {
    width: 100%;
    position: absolute;

    .chuKuZuoyeWarp-body-queryIpt {
      // margin-top: 5px;
      width: 100%;

      // border: solid 1px;
      display: flex;
      ul {
        flex: 1;
        flex-direction: column;
        display: flex;
        li {
          margin-top: 5px;
          list-style: none;
        }
      }
    }

    .chuKuZuoyeWarp-body-btn {
      margin-top: 5px;
    }
    .chuKuZuoyeWarp-body-table {
      margin-top: 5px;
    }
  }
  /deep/ .el-textarea .el-textarea__inner {
    resize: none;
  }
}
</style>
